import React, { useEffect, useState } from "react"
import { Container } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Link, useNavigate } from "react-router-dom"
import { Row, Form, Modal } from "reactstrap"
import Select from "react-select"

// editor
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import {
  assingOptions,
  cityOptions,
  colourStyles,
  countryOptions,
  locationOptions,
  stateOptions,
  statusOptions,
} from "common/utils/ComonOptions"
import axios from "axios"
import AccessDeniedPopup from "components/Common/AccessDeniedPopup"
import configure from "configure"
import Swal from "sweetalert2"
import Loader from "components/Common/Loader"
import secureLocalStorage from "react-secure-storage"
import { type } from "utils/common-options"

const AddLead = () => {
  const [fixButtons, setFixButtons] = useState(false)
  const [formRows, setFormRows] = useState([{}])
  const [loading, setLoading] = useState(false)
  const [status, setStatus] = useState([])
  const [company_name, setCompany_name] = useState("")
  const [website, setWebsite] = useState("")
  const [email, setEmail] = useState("")
  const [phone, setPhone] = useState("")
  const [country, setCountry] = useState("")
  const [state, setState] = useState("")
  const [city, setCity] = useState("")
  const [address, setAddress] = useState("")
  const [picode, setPincode] = useState("")
  const [description, setDescription] = useState("")
  const [countrycode, setCountryCode] = useState("")
  const [statecode, setStateCode] = useState("")
  const [citycode, setCityCode] = useState("")
  const [source_dependent, setSourceDependent] = useState(false)
  const [status_option, setStatus_option] = useState([])
  const [country_option, setCountry_option] = useState([])
  const [state_option, setState_option] = useState([])
  const [city_option, setCity_option] = useState([])
  const [source_option, setSourceOption] = useState([])
  const [source_name, setSourceName] = useState([])
  const [error, setError] = useState(null)
  const [persondetail, setPersondetail] = useState([])
  const [auth_id, setAuth_id] = useState(null)
  const [source, setSource] = useState([])
  const [lead_type, setLead_type] = useState([])

  useEffect(() => {
    const authUser = secureLocalStorage.getItem("User");
    setAuth_id(authUser.id)
    fetchStatus()
    fetchCountry()
  }, [])

  // Fetch Status
  const fetchStatus = async () => {
    setLoading(true);
    const token = secureLocalStorage.getItem("Token");
    try {
      const resp = await axios({
        method: "GET",
        url: `${configure.apiUrl}/leads/all/status`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setStatus_option(
        resp.data.status.map((item) => ({
          label: item.name,
          value: item.id,
        }))
      );

      setLoading(false);
    } catch (err) {
      console.log("leads - error", err);
      setLoading(false);
    }
  }

  // Fetch Country
  const fetchCountry = async () => {
    setLoading(true)
    try {
      const responce = await axios({
        method: "get",
        url: `${configure.apiUrl}/all/countries`,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then(res => {
        setCountry_option(
          res.data.countries.map(obj => ({
            label: obj.name,
            value: obj.id,
          }))
        )
        // console.log("Country", country_option)
        setLoading(false)
      })
    } catch (error) {
      console.log("Add-lead-Country", error)
      setLoading(false)
    }
  }

  //  Fetch State
  const fetchState = async e => {
    setLoading(true)
    setCountryCode(e.value)
    try {
      const responce = await axios({
        method: "post",
        url: `${configure.apiUrl}/all/states`,
        data: {
          country_id: e.value
        },
      }).then(res => {
        setLoading(false)
        setState_option(
          res.data.states.map(obj => ({
            value: obj.id,
            label: obj.name,
          }))
        )
      })
    } catch (error) {
      console.log("Add-lead-State", error)
      setLoading(false)
    }
  }

  // Fetch City
  const fetchCity = async e => {
    setLoading(true)
    setStateCode(e.value)
    try {
      const responce = await axios({
        method: "post",
        url: `${configure.apiUrl}/all/cities`,
        data: {
          state_id: e.value
        },
      }).then(res => {
        setLoading(false)
        setCity_option(
          res.data.cities.map(obj => ({
            value: obj.id,
            label: obj.name,
          }))
        )
      })
    } catch (error) {
      console.log("Add-Lead-FetchCity", error), setLoading(false)
    }
  }

  //  Save Lead
  const SaveLead = async e => {
    e.preventDefault()
    if (
      status.length != 0 &&
      countrycode.length != 0 &&
      statecode.length != 0 &&
      description.length != 0
    ) {
      setLoading(true)
      const payload = {
        person_details: persondetail,
        status: status.value,
        company: company_name,
        website,
        email,
        phonenumber: phone,
        country: countrycode,
        address,
        zip: picode,
        description,
        state: statecode,
        city: citycode || "", // safe fallback
        source_name: source_name?.value,
        source: source?.value,
        lead_type:lead_type?.value
      };

      const token = secureLocalStorage.getItem("Token");
      try {
        const response = await axios({
          method: "POST",
          url: `${configure.apiUrl}/leads`,
          data: payload,
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
          },
        }).then(res => {
          setLoading(false)
          // console.log("lead Data", res)
          Swal.fire({
            icon: "success",
            text: "Lead Added Scuccesfully",
          }).then(data => {
            navigate(`${configure.appUrl}/lead-section`)
          })
        })
      } catch (error) {
        console.log(error)
        setLoading(false)
      }
    } else {
      setError(true)
    }
  }

  const navigate = useNavigate(-1)

  // dynamic form add
  const onAddFormRow = () => {
    setFormRows([...formRows, {}])
  }

  const onDeleteFormRow = index => {
    const newInputs = [...formRows]
    newInputs.splice(index, 1)
    setFormRows(newInputs)
  }

  const onPersonName = (e, key) => {
    let values = [...formRows]
    values[key][e.target.name] = e.target.value
    setPersondetail(values)
  }
  const onPersonEmail = (e, key) => {
    let values = [...formRows]
    values[key][e.target.name] = e.target.value
    setPersondetail(values)
  }
  const onPersonPhone = (e, key) => {
    let values = [...formRows]
    values[key][e.target.name] = e.target.value
    setPersondetail(values)
  }
  const onPersonAuthority = (e, key) => {
    let values = [...formRows]
    values[key][e.target.name] = e.target.value
    setPersondetail(values)
  }
  const onPersonPrimary = (e, key) => {
    let values = [...formRows]
    values[key][e.target.name] = e.target.value
    setPersondetail(values)
  }
  const onFacebook = (e, key) => {
    let values = [...formRows]
    values[key][e.target.name] = e.target.value
    setPersondetail(values)
  }
  const onLinkdin = (e, key) => {
    let values = [...formRows]
    values[key][e.target.name] = e.target.value
    setPersondetail(values)
  }


  const onChangeCountry = async e => {
    setLoading(true)
    const fromData = new FormData()
    fromData.append("country_id", 1)
    try {
      await axios({
        method: "post",
        url: `${configure.api}/lead_belong`,
        data: fromData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then(res => {
        setSourceOption(
          res.data.data.lead_source?.filter((obj) => obj?.leadname?.toLowerCase() != "introducer").map(item => ({
            value: item.id,
            label: item.leadname,
          }))
        )
        setLoading(false)
      })
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }
  useEffect(() => {
    onChangeCountry()
  }, [])
  const getCustmerData = async (e) => {
    setLoading(true);
    try {
      const authUser = secureLocalStorage.getItem("Token");
      const resp = await axios({
        method: "get",
        url: `${configure.apiUrl}/customers`,
        headers: {
          Authorization: `Bearer ${authUser}`,
        },
      }).then((res) => {
        setSourceDependent({ label: e.label, list: res.data.customers })
        setLoading(false);
      });
    } catch (error) {
      console.log("Customer Data Error", error);
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      {loading && <Loader />}
      <div className="page-content mb-3">
        <Container fluid>
          <Breadcrumbs title={"Dashboard"} breadcrumbItem={"Add Lead"} />
          <Row className="px-1">
            <Form onSubmit={SaveLead}>
              <div
                className={`flex-column fixed-buttons pt-2 ${fixButtons ? "d-flex" : "d-none"
                  }`}
              >
                <button
                  type="submit"
                  className="btn btn-save fix-btn btn-label pe-0"
                >
                  <i className="fas fa-save me-2 label-icon"></i>
                  <span>Save</span>
                </button>
                <a
                  onClick={() => navigate(-1)}
                  className="btn btn-red  fix-btn  btn-label pe-0"
                >
                  <i className="dripicons-cross me-2 icon-center label-icon"></i>
                  <span>Cancel</span>
                </a>
              </div>
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <div className="col-md-6 mb-3">
                  <h5 className="mb-3">Lead Information</h5>
                </div>
                <div className="col-md-6 mb-3 text-end">
                  <button
                    type="submit"
                    onClick={e => SaveLead(e)}
                    className=" btn ms-md-2 btn-save  btn-label"
                  >
                    <i className="fas fa-save me-1 label-icon"></i> save
                  </button>
                  <a
                    onClick={e => {
                      navigate(-1)
                    }}
                    className=" btn ms-md-2 btn-red  btn-label "
                  >
                    <i className="dripicons-cross me-2 icon-center label-icon"></i>
                    CANCEL
                  </a>
                </div>

                {/* Lead Information  */}
                <div className="row">
                  <div className="col-md-3 mb-3">
                    <label htmlFor="">
                      Status <span className="text-danger">*</span>{" "}
                    </label>
                    <Select
                      placeholder="Select Status"
                      className="basic-multi-select"
                      classNamePrefix=" select"
                      styles={colourStyles}
                      options={status_option}
                      onChange={e => setStatus(e)}
                    />
                    <span
                      className="text-danger"
                      style={{
                        fontSize: "12px",
                        fontWeight: "500",
                        paddingTop: "7px",
                      }}
                    >
                      {(status.length == 0) == error
                        ? "Please select Lead Status"
                        : null}
                    </span>
                  </div>
                  <div className="col-md-3 mb-3">
                    <label htmlFor="">
                      Source
                    </label>
                    <Select
                      onChange={e => {
                        setSource(e)
                        if (e.label == "Customer") {
                          getCustmerData(e)
                        } else {
                          setSourceDependent(false)
                        }
                      }}
                      placeholder="Select Source"
                      className="basic-multi-select"
                      classNamePrefix=" select"
                      styles={colourStyles}
                      options={source_option}
                    />
                    <span
                      className="text-danger"
                      style={{
                        fontSize: "12px",
                        fontWeight: "500",
                        paddingTop: "7px",
                      }}
                    >
                      {(source.length == 0) == error
                        ? "Please select Source"
                        : null}
                    </span>
                  </div>
                  {source_dependent && (
                    <div className="col-md-3 mb-3">
                      <label htmlFor="">
                        {source_dependent?.label}{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Select
                        onChange={e => {
                          setSourceName(e)
                        }}
                        placeholder="Select Customer"
                        className="basic-multi-select"
                        classNamePrefix=" select"
                        styles={colourStyles}
                        options={source_dependent?.list.map(cust => ({
                          label: cust.company,
                          value: cust.id,
                        }))}
                      />
                    </div>
                  )}
                  <div className="col-md-3 mb-3 mb-md-0">
                    <label htmlFor="">
                      Lead Type 
                    </label>
                    <Select
                      onChange={e => setLead_type(e)}
                      placeholder="Select Lead Type"
                      className="basic-multi-select"
                      classNamePrefix=" select"
                      styles={colourStyles}
                      options={type}
                    />
                  </div>
                </div>
              </Row>

              {/* Company info */}
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <h5 className="mb-3">Company Information</h5>
                <div className="col-md-4 mt-2 mb-3 mb-md-0">
                  <label htmlFor="">Company Name</label>

                  <input
                    type="text"
                    placeholder="Enter Company Name"
                    className="form-control "
                    onChange={e => setCompany_name(e.target.value)}
                    defaultValue={company_name}
                  />
                </div>

                <div className="col-md-4 mt-2 mb-3 mb-md-0">
                  <label htmlFor="">Website</label>
                  <input
                    type="text"
                    placeholder="Enter Website"
                    className="form-control "
                    onChange={e => setWebsite(e.target.value)}
                    defaultValue={website}
                  />
                </div>

                <div className="col-md-4 mt-2 mb-3 mb-md-0">
                  <label htmlFor="">Email Address</label>
                  <input
                    type="email"
                    placeholder="Enter Email Address"
                    className="form-control "
                    onChange={e => setEmail(e.target.value)}
                    defaultValue={email}
                  />
                </div>

                <div className="col-md-4 mt-2 mb-3 mb-md-0 mt-3">
                  <label htmlFor="">Phone</label>
                  <input
                    type="text"
                    placeholder="Enter Phone"
                    className="form-control "
                    onChange={e => setPhone(e.target.value)}
                    defaultValue={phone}
                  />
                </div>
              </Row>

              {/* Address */}
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <h5 className="mb-3">Address</h5>
                <div className="col-md-4 mb-3">
                  <label htmlFor="">
                    Country <span className="text-danger">*</span>{" "}
                  </label>
                  <Select
                    placeholder="Select Location"
                    className="basic-multi-select"
                    classNamePrefix=" select"
                    styles={colourStyles}
                    options={country_option}
                    onChange={fetchState}
                  />
                  <span
                    className="text-danger"
                    style={{
                      fontSize: "12px",
                      fontWeight: "500",
                      paddingTop: "7px",
                    }}
                  >
                    {(countrycode.length == 0) == error
                      ? "Please Select Country"
                      : null}
                  </span>
                </div>
                <div className="col-md-4 mb-3">
                  <label htmlFor="">
                    State <span className="text-danger">*</span>{" "}
                  </label>
                  <Select
                    onChange={fetchCity}
                    placeholder="Select State"
                    className="basic-multi-select"
                    classNamePrefix=" select"
                    styles={colourStyles}
                    options={state_option}
                  />
                  <span
                    className="text-danger"
                    style={{
                      fontSize: "12px",
                      fontWeight: "500",
                      paddingTop: "7px",
                    }}
                  >
                    {(statecode.length == 0) == error
                      ? "Please Select State"
                      : null}
                  </span>
                </div>
                <div className="col-md-4 mb-3">
                  <label htmlFor="">
                    City <span className="text-danger">*</span>{" "}
                  </label>
                  <Select
                    onChange={e => setCityCode(e.value)}
                    placeholder="Select City"
                    className="basic-multi-select"
                    classNamePrefix=" select"
                    styles={colourStyles}
                    options={city_option}
                  />
                  <span
                    className="text-danger"
                    style={{
                      fontSize: "12px",
                      fontWeight: "500",
                      paddingTop: "7px",
                    }}
                  >
                    {(citycode.length == 0) == error
                      ? "Please Select City"
                      : null}
                  </span>
                </div>
                <div className="col-md-8 mb-3 mt-2">
                  <label htmlFor="">Address</label>
                  <input
                    type="text"
                    placeholder="Enter Address"
                    className="form-control "
                    onChange={e => setAddress(e.target.value)}
                    defaultValue={address}
                  />
                </div>

                <div className="col-md-4 mb-3 mt-2">
                  <label htmlFor="">Pin Code</label>
                  <input
                    type="text"
                    placeholder="Enter Pin Code"
                    className="form-control "
                    onChange={e => setPincode(e.target.value)}
                    defaultValue={picode}
                  />
                </div>

                <div className="col-12 mt-2 lead-desc">
                  <div className="d-flex justify-space-between">
                    <label htmlFor="">
                      Description <span className="text-danger">*</span>
                    </label>
                    <span
                      className="text-danger"
                      style={{
                        fontSize: "12px",
                        fontWeight: "500",
                        paddingTop: "7px",
                      }}
                    >
                      {(description.length == 0) == error
                        ? "Please enter description"
                        : null}
                    </span>
                  </div>

                  <CKEditor
                    editor={ClassicEditor}
                    data=""
                    onReady={editor => {
                      // You can store the "editor" and use when it is needed.
                    }}
                    onChange={(event, editor) => {
                      const data = editor.getData()
                      setDescription(data)
                    }}
                  />
                </div>
              </Row>

              {/* Contact */}
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <div className="d-flex justify-content-between">
                  <h5 className="text-dark"> Contact</h5>
                  <div className="text-end mb-3">
                    <a
                      onClick={e => {
                        e.preventDefault()
                        onAddFormRow()
                      }}
                      className="btn btn-save btn-label"
                    >
                      <i className="fas fa-plus me-2 label-icon"></i>
                      Add More
                    </a>
                  </div>
                </div>
                {(formRows || []).map((formRow, key) => (
                  <div key={key} className="mb-2">
                    <div className="d-flex">
                      <div className="contact-form d-flex gap-3 align-items-center">
                        <div className="contact-column mb-3 mb-md-0">
                          <label htmlFor="">Name</label>
                          <input
                            type="text"
                            name="person_name"
                            placeholder="Enter Name"
                            className="form-control "
                            onChange={e => onPersonName(e, key)}
                          />
                        </div>
                        <div className="contact-column mb-3 mb-md-0">
                          <label htmlFor="">Email</label>
                          <input
                            type="text"
                            name="person_email"
                            placeholder="Enter Email"
                            className="form-control "
                            onChange={e => onPersonEmail(e, key)}
                          />
                        </div>
                        <div className="contact-column mb-3 mb-md-0">
                          <label htmlFor="">Phone</label>
                          <input
                            type="text"
                            name="person_phone"
                            placeholder="Enter Number"
                            className="form-control "
                            onChange={e => onPersonPhone(e, key)}
                          />
                        </div>
                        <div className="contact-column-2 mb-3 mb-md-0 d-flex gap-3">
                          <div className="text-center">
                            <label className="d-block">Authority</label>
                            <select
                              className="form-control"
                              name="decision_maker"
                              onChange={e => onPersonAuthority(e, key)}
                            >
                              <option value="off">No</option>
                              <option value="on">Yes</option>
                            </select>
                          </div>
                          <div className="text-center me-2">
                            <label className="d-block">Primary</label>
                            <select
                              className="form-control"
                              name="chk_contact"
                              onChange={e => onPersonPrimary(e, key)}
                            >
                              <option value="false">No</option>
                              <option value="true">Yes</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="contact-btns pe-0 d-flex justify-content-end align-items-end mb-3 mb-md-0">
                        <div className="text-end">
                          {key !== 0 ? (
                            <>
                              <a
                                onClick={e => {
                                  e.preventDefault()
                                  onDeleteFormRow(key)
                                }}
                                className="btn btn-red"
                              >
                                <i className="fas fa-trash-alt"></i>
                              </a>
                            </>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="row mt-4 pb-10">
                      {/* <div className="col-4 mb-3 mb-md-0">
                            <label htmlFor="">Designation</label>
                            <input
                              type="text"
                              name="person_designation"
                              onChange={e => onPersonDesignation(e, key)}
                              placeholder=" Designation"
                              className="form-control "
                            />
                          </div> */}
                      <div className="col-4 mb-3 mt-2 mb-md-0">
                        <label htmlFor="">Facebook Profile Link </label>
                        <input
                          type="text"
                          name="facebook"
                          placeholder="Enter Facebook Profile Link"
                          className="form-control "
                          onChange={e => onFacebook(e, key)}
                        />
                      </div>
                      <div className="col-4 mb-3 mt-2 mb-md-0">
                        <label htmlFor="">LinkedIn Profile Link</label>
                        <input
                          type="text"
                          name="linkedin"
                          placeholder="Enter LinkedIn Profile Link"
                          className="form-control "
                          onChange={e => onLinkdin(e, key)}
                        />
                      </div>
                    </div>
                    {key !== formRows.length - 1 ? (
                      <div className="border-bottom mb-3 mt-4 "></div>
                    ) : null}
                  </div>
                ))}
              </Row>
            </Form>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AddLead
